import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PosSalesService {


	constructor(private http: HttpClient) { }
	url = environment.serverAPI5 + '/' + 'api/sales';

	url1 = environment.serverAPI1 + "/api";

	url2 = environment.serverAPI5 + '/' + 'api';

	url3 = environment.serverAPI5 + '/' + 'api/salesimport';

	searchPurchase(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getPurchase(Page: number, size: number, sort: any): Observable<Object> {
		return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
	}
	getAllBillerDropDown(): Observable<Object> {
		return this.http.get(`${this.url}/dropdown`);
	}

	getPurchaseById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	}
	getBypackinglist(query: any, Page: any, size: any, sort: any): Observable<Object> {

		return this.http.get(`${this.url}/${query}?&page=${Page}&size=${size}&sort=${sort}`);
	}


	createSales(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, Purchase);
	}

	createSalesPos(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/pos`, Purchase);
	}
	deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}
	downloadSalesReport(Page: number, size: number, sort, selectionSales): Observable<any> {
		return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionSales, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}
	// createTransfer(Transfer: any): Observable<Response[]> {
	// 	return this.http.post<Response[]>(`${this.url}`, Transfer);
	// }


	downloadSalesTemplate(): Observable<any> {
		return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}

	getTransferById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	}
	deleteBySalesId(salesId: any): Observable<Object> {
		return this.http.delete(`${this.url}/${salesId}`);
	}

	getAllKitchenStatus(): Observable<Object> {
		return this.http.get(`${this.url2}`);
	}

	getSalesKitechUpdate(id: any, status: any, saleId: any): Observable<Object> {
		return this.http.get(`${this.url}/kitchen/${id}/${status}/${saleId}`);
	}

	searchKitchenStatus(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/cutter/kitchen-status/condition`, requestBody);
	}

	KitchenStatus(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/kitchen/condition`, requestBody);
	}

	KitchenStatusCondition(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/kitchen/status/condition`, requestBody);
	}

	searchParckerStatus(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/packer/status/condition`, requestBody);
	}

	waiterTableStatus(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/waiter/table/condition`, requestBody);
	}

	waiterKotTableOrder(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/waiter/kot/order/condition`, requestBody);
	}


	KotStatusCondition(value: any): Observable<Response[]> {

		const requestBody = {
			"searchEntity": value

		};
		return this.http.post<Response[]>(`${this.url2}/kot/status/condition`, requestBody);
	}


	getKotKitchenUpdate(id: any, status: any, saleId: any): Observable<Object> {
		return this.http.get(`${this.url2}/kot/kitchen/${id}/${status}/${saleId}`);
	}

	getKotItemStatusUpdate(id: any, kotItemId: any): Observable<Object> {
		return this.http.get(`${this.url2}/kot/updateItemStatus/${id}/${kotItemId}`);
	}

	getKotstatusUpdate(id: any): Observable<Object> {
		return this.http.get(`${this.url2}/kot/updateItemStatus/${id}`);
	}

	getBySalesIdColumnMap(id: any): Observable<Object> {
		return this.http.get(`${this.url1}/colMap/${id}`);
	}

	saveSalesColumnMap(sales: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url1}/new`, sales);
	}

}
